<template>
  <b-modal
    class="createApiKeyModal"
    hide-header
    hide-footer
    centered
    size="lg"
    ref="createApiKeyModal"
    @open="open"
  >
    <b-form @submit="onSubmit" @reset="onReset" class="p-4">
      <b-row>
        <b-col>
          <b-form-row>
            <b-col>
              <b-form-group>
                <b-form-input
                  v-model="form.title"
                  :state="form.title.length > 0 && form.title.length <= 64"
                  placeholder="Key Name"
                />
                <b-form-text id="input-formatter-help" class="pull-right">{{form.title.length}} / 64</b-form-text>
              </b-form-group>
            </b-col>
          </b-form-row>
          <b-form-row>
            <b-col>
              <b-form-group>
                <template slot="label">
                  <h4 class="mt-0">Scopes</h4>
                  <b-form-checkbox
                    v-model="allSelected"
                    :indeterminate="indeterminate"
                    @change="toggleAllScopes"
                  >receipt.*</b-form-checkbox>
                </template>
                <b-form-checkbox-group
                  v-model="form.scopes"
                  :options="scopes"
                  class="ml-4"
                  aria-label="Individual flavours"
                  stacked
                />
              </b-form-group>
            </b-col>
          </b-form-row>
        </b-col>
      </b-row>
      <b-row class="form-actions">
        <b-col>
          <p-button type="success" round size="sm" class="pull-right" :disabled="hasError() || processing" @click.native="onSubmitForm" :loading="processing">Create Key</p-button>
          <p-button type="danger" round size="sm" class="pull-right mr-2" @click.native="onCancel">Cancel</p-button>
          <span class="pull-right mr-4 error text-danger" v-if="error">{{error}}</span>
        </b-col>
      </b-row>
    </b-form>
    <b-loading :loading="processing" />
  </b-modal>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      processing: false,
      form: {
        title: '',
        scopes: [],
        error: {
          title: false,
        },
      },
      allSelected: false,
      indeterminate: false,
      scopes: [
        'receipt.create',
        'receipt.read'
      ]
    }
  },
  watch: {
    form: {
      handler() {
        this.validate()
      },
      deep: true
    },
    'form.scopes': function(newVal, oldVal) {
      if (newVal.length === 0) {
        this.indeterminate = false
        this.allSelected = false
      } else if (newVal.length === this.scopes.length) {
        this.indeterminate = false
        this.allSelected = true
      } else {
        this.indeterminate = true
        this.allSelected = false
      }
    }
  },
  computed: {
    ...mapGetters([
      'error',
      'loading',
      'user',
    ])
  },
  methods: {
    open() {
      this.resetFormFields()
      this.$refs.createApiKeyModal.show()
    },
    close() {
      this.$refs.createApiKeyModal.hide()
    },
    validate() {
      this.form.error.title = !this.form.title
    },
    hasError() {
      return Object.keys(this.form.error).some((key) => this.form.error[key])
    },
    onSubmit() {
      this.onSubmitForm()
    },
    onCancel() {
      this.close()
    },
    onReset() {
      this.resetFormFields()
    },
    resetFormFields() {
      this.form = {
        title: '',
        scopes: [],
        error: {
          title: false,
        },
      }
      this.allSelected = false
      this.indeterminate = false
      this.processing = false
    },
    onSubmitForm(e) {
      e && e.preventDefault()
      if (!this.hasError()) {
        this.processing = true
        const {error, ...payload} = this.form
        this.$store.dispatch('createApiKey', payload)
        .then(() => {
          this.$bvToast.toast('This key has been successfully generated.', {
            title: `Key - ${this.form.title}`,
            variant: 'custom',
            autoHideDelay: 2000,
            solid: true
          })
        })
        .finally(() => {
          this.processing = false
          this.close()
        })
      }
    },
    toggleAllScopes(checked) {
      this.form.scopes = checked ? this.scopes.slice() : []
    }
  },
  created() {
    this.resetFormFields()
  },
}
</script>
<style lang="scss">
.createApiKeyModal {
  .modal-header {
    border-bottom: 0 none;
  }
  .form-control {
    border: solid 1px #ccc;
  }
  .form-actions {
    .btn {
      min-width: 100px;
    }
  }
}
</style>
